import React from 'react'
import { Alert, Card, CardBody, CardHeader, Button, Table, Spinner, Label, Input } from 'reactstrap'

function PaginatedListCard({
  title,
  isLoading,
  error,
  onRefresh,
  refreshLabel = 'Refrescar',
  emptyMessage = 'No hay registros.',
  columns,
  rows,
  page,
  totalPages,
  totalElements,
  size,
  onPageChange,
  onSizeChange,
  pageSizeId = 'page-size',
}) {
  const safeColumns = Array.isArray(columns) ? columns : []
  const safeRows = Array.isArray(rows) ? rows : []

  return (
    <Card className="form-card">
      <CardHeader className="form-card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">{title}</h5>
        <Button color="secondary" size="sm" onClick={onRefresh} disabled={isLoading}>
          {isLoading ? 'Cargando...' : refreshLabel}
        </Button>
      </CardHeader>
      <CardBody className="form-card-body">
        {error && <Alert color="danger">{error}</Alert>}
        {isLoading ? (
          <div className="d-flex justify-content-center py-3">
            <Spinner color="primary" />
          </div>
        ) : safeRows.length === 0 ? (
          <p className="text-muted mb-0">{emptyMessage}</p>
        ) : (
          <Table responsive hover>
            <thead>
              <tr>
                {safeColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {safeRows.map((row) => (
                <tr key={row.key}>
                  {row.cells.map((cell, index) => (
                    <td key={`${row.key}-${index}`}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
          <div className="text-muted">
            Total: {totalElements}
          </div>
          <div className="d-flex align-items-center gap-2">
            <Button
              color="secondary"
              size="sm"
              disabled={isLoading || page <= 0}
              onClick={() => onPageChange(page - 1)}
            >
              Anterior
            </Button>
            <span className="text-muted">
              Página {totalPages === 0 ? 0 : page + 1} de {totalPages}
            </span>
            <Button
              color="secondary"
              size="sm"
              disabled={isLoading || page + 1 >= totalPages}
              onClick={() => onPageChange(page + 1)}
            >
              Siguiente
            </Button>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Label className="mb-0" for={pageSizeId}>Filas</Label>
            <Input
              type="select"
              id={pageSizeId}
              value={size}
              onChange={(event) => onSizeChange(Number(event.target.value))}
              style={{ width: '90px' }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Input>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default PaginatedListCard
